import React from 'react';

const BeltItem = ({ title, image, children }) =>
	<div>
		<br />
		<div class="media">
			<aside class="media-left">
				<img src={image} width="100" alt="" />
			</aside>
			<div class="media-content">
				<h1 class="title is-5 is-spaced is-marginless">{title}</h1>
				<p class="has-text-justified">
					{children}
				</p>
			</div>
		</div>
	</div>

export default BeltItem;



// WEBPACK FOOTER //
// ./src/components/About/BeltItem.js